import { render, staticRenderFns } from "./ModuleDetail.vue?vue&type=template&id=7f2dd979&scoped=true"
import script from "./ModuleDetail.vue?vue&type=script&lang=js"
export * from "./ModuleDetail.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetail.vue?vue&type=style&index=0&id=7f2dd979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2dd979",
  null
  
)

export default component.exports